<template>
  <v-app>
    <v-toolbar app fixed clipped-left dark color="blue darken-3">

      <v-spacer></v-spacer>

      <div v-show="!connected">
        <v-tooltip bottom transition="scale-transition">
          <v-btn icon slot="activator" disabled>
            <v-icon>mdi-cloud-off-outline</v-icon>
          </v-btn>
          <span>{{ $t('message.not_connected') }}</span>
        </v-tooltip>
      </div>      

      <div class="some-margin use-hand-cursor">
        <v-tooltip bottom>
          <img src="/static/img/flag-of-Brazil1.png"
            alt="Brazil flag" width="26" height="18"
            slot="activator"
            @click="changeLanguage('pt_BR')"
          >
          <span>Português</span>
        </v-tooltip>
      </div>

      <div class="some-margin use-hand-cursor">
        <v-tooltip bottom>
          <img src="/static/img/flag-of-United-States-of-America1.png"
            alt="United States of America flag" width="26" height="18"
            slot="activator"
            @click="changeLanguage('en_US')"
          >
          <span>English</span>
        </v-tooltip>
      </div>
      
      <div class="some-margin use-hand-cursor">
        <v-tooltip bottom>
          <img 
            src="/static/img/flag-of-Spain1.png"
            alt="Spain flag" width="26" height="18"
            slot="activator"
            @click="changeLanguage('es_ES')"
          >
          <span>Español</span>
        </v-tooltip>
      </div>

      <div>
        <v-btn icon disabled>
          <i>Beta</i>
        </v-btn>          
      </div>

      <v-menu left>
        
        <div slot="activator">
          <v-tooltip left transition="scale-transition">
            <v-btn icon slot="activator">
              <v-icon large>account_circle</v-icon>
            </v-btn>
            <span>{{ $t('message.inobram_account') }} - {{ user.name }} </span>
          </v-tooltip>
        </div>

        <v-card class="mt-5">
          <v-list>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon large>account_circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <!-- add link to profile -->
                <v-list-tile-title>{{ user.name }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ user.email }}
                </v-list-tile-sub-title>
              </v-list-tile-content>  
              <v-list-tile-action>
                <!-- TODO: IMPLEMENT IN THE FUTURE -->
                <!-- <v-btn @click="goToProfile" flat small class="ml-3">
                  Ver perfil
                </v-btn> -->
              </v-list-tile-action>         
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                  <v-btn round flat @click="onSignout">{{ $t('message.exit') }}</v-btn>             
              </v-list-tile-action>                
            </v-list-tile>
          </v-list>            

        </v-card>
      </v-menu>

    </v-toolbar>    

    <v-content class="grey lighten-2">

      <router-view></router-view>

    </v-content>

    <app-snackbar></app-snackbar>

  </v-app>
</template>

<script>
export default {
  data () {
    return {
      drawer: false,
      cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
      ],
      items: [
        { icon: 'dashboard', text: 'Dashboard', route: '/dashboard' },
        { icon: 'memory', text: this.$t('message.devices'), route: '/devices' },
        { icon: 'store', text: this.$t('message.nuclei'), route: '/nuclei' }
      ]
    }
  },
  computed: {
    locale () {
      return this.$store.getters.language
    },
    connected () {
      return this.$store.getters.connected
    },
    user () {
      return this.$store.getters.user
    },
    email () {
      return this.user.email ? this.user.email : ''
    }
  },
  watch: {
    locale (value) {
      this.items = [
        { icon: 'dashboard', text: 'Dashboard', route: '/dashboard' },
        { icon: 'memory', text: this.$t('message.devices'), route: '/devices' },
        { icon: 'store', text: this.$t('message.nuclei'), route: '/nuclei' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: this.$t('message.entries'),
          model: false,
          children: [
            { text: this.$t('message.account'), route: '/account' },
            { text: this.$t('message.devices'), route: '/devices' },
            { text: this.$t('message.nuclei'), route: '/nuclei' },
            { text: this.$t('message.country'), route: '/countries' },
            { text: this.$t('message.state'), route: '/states' },
            { text: this.$t('message.city'), route: '/cities' },
            { text: this.$t('message.sex'), route: '/sexes' },
            { text: this.$t('message.device_models'), route: '/deviceModels' },
            { text: this.$t('message.device_types'), route: '/deviceTypes' },
            { text: this.$t('message.mortalities'), route: '/mortalities' },
            { text: this.$t('message.walls'), route: '/walls' },
            { text: this.$t('message.floors'), route: '/floors' },
            { text: this.$t('message.roofs'), route: '/roofs' },
            { text: this.$t('message.inner_curtains'), route: '/innerCurtains' },
            { text: this.$t('message.outer_curtains'), route: '/outerCurtains' },
            { text: this.$t('message.linings'), route: '/linings' },
            { text: this.$t('message.evaporative_plates'), route: '/evaporativePlates' },
            { text: this.$t('message.lighting_systems'), route: '/lightingSystems' },
            { text: this.$t('message.internet_access_types'), route: '/internetAccessTypes' },
            { text: this.$t('message.barns'), route: '/barns' },
            { text: this.$t('message.barn_types'), route: '/barnTypes' },
            { text: this.$t('message.voltage_types'), route: '/voltageTypes' },
            { text: this.$t('message.device_types'), route: '/deviceTypes' },
            { text: this.$t('message.air_inlets'), route: '/airInlets' },
            { text: this.$t('message.silo_types'), route: '/siloTypes' },
            { text: this.$t('message.water_boxes'), route: '/waterBoxes' },
            { text: this.$t('message.watchdog_systems'), route: '/watchdogSystems' },
            { text: this.$t('message.batch_states'), route: '/batchStates' },
            { text: this.$t('message.device_models'), route: '/deviceModels' },
            { text: this.$t('message.manufacturers'), route: '/manufacturers' }
          ]
        }
      ]
    },
    user (val) {
      if (!val) {
        this.$router.push('/signin')
      }
    }
  },
  methods: {
    onSignout () {
      this.$store.dispatch('signUserOut')
    },
    goToProfile () {
      this.$router.push('/profile')
    },
    goTo (route) {
      if (route === '/dashboard') {
        this.$store.dispatch('setDashboardViewMode', {
          show: true
        })
      } else {
        this.$store.dispatch('setDashboardViewMode', {
          show: false
        })
      }
      this.$router.push(route)
    },
    changeLanguage (language) {
      this.$i18n.locale = language
      this.$store.dispatch('setLanguage', language)
    }
  },
  name: 'App'
}
</script>

<style scoped>

  .card__title {
    padding-top: 0px;
  }

  .some-margin {
    margin-top: 8px;
    margin-right: 5px;
  }

  .use-hand-cursor {
    cursor: pointer;
  }

</style>







// WEBPACK FOOTER //
// src/components/Base/Navigation.vue